import { Component, OnDestroy, OnInit } from '@angular/core';
import { SnackbarService } from 'src/app/_services/snackBar.service';
import { Router } from '@angular/router';
import { GlobalService } from 'src/app/_services/global.service';

@Component({
  selector: 'app-snack-bar-error',
  templateUrl: './snack-bar-error.component.html',
  styleUrls: ['./snack-bar-error.component.scss']
})

export class SnackBarErrorComponent implements OnInit {
  message: string;
  listType: string;
  currLang;
  dir;
  constructor(private snackbarService: SnackbarService,    
    private router: Router,
    private globalService: GlobalService
    ) { }

  ngOnInit(): void {
    this.listType = window.location.pathname.split('/')[2];
    
    this.router.events.subscribe((res: any) => {
      if (res.url) {
        this.listType = res.url.split('/')[2];        
      }
    })

    this.globalService.getLang().subscribe(lng =>{
      this.currLang = lng;
      this.dir = this.currLang == 'ar' ? 'rtl' : 'ltr'
    });
    this.snackbarService.getSnackBarMessage().subscribe((res: string) => {
      if (res !== null) {
        this.message = res;
      }
    })
  }
}